export const RESUME_ALLOWED_TYPES = ['.doc', '.docx', '.pdf'];
export const RESUME_MAX_SIZE_MB = 20;
export const RESUME_MAX_SIZE_BYTES = RESUME_MAX_SIZE_MB * 1024 * 1024;

export interface FileValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateResumeFile = (file: File): FileValidationResult => {
  const fileName = file.name.toLowerCase();
  const hasValidExtension = RESUME_ALLOWED_TYPES.some((type) =>
    fileName.endsWith(type.toLowerCase()),
  );

  if (!hasValidExtension) {
    return {
      isValid: false,
      error: `File format not allowed. Please use only: ${RESUME_ALLOWED_TYPES.join(', ')}`,
    };
  }

  if (file.size > RESUME_MAX_SIZE_BYTES) {
    return {
      isValid: false,
      error: `File too large. Maximum allowed size is ${RESUME_MAX_SIZE_MB}MB`,
    };
  }

  return { isValid: true };
};
